__turbopack_context__.v({
  "hint": "_2VSc1W_hint",
  "label": "_2VSc1W_label",
  "root": "_2VSc1W_root",
});
